export default __webpack_public_path__ + "static/marking-99fce47e97503fead76a15d2080aaca0.png";